  <div class="development-title pl-[30px] sticky !z-20 top-0">
    Pre-Qualification Questionnaire (PQQ)
  </div>
  <div class="!pt-0 !pb-0">
    <!-- Project Details -->
    <div class="container-fluid flex justify-center h-auto p-[29px] !pt-0 !m-[3px] !mt-[0px] !mb-[5px] !pb-[0px]">
      <div class="!pb-0 w-full !pt-[59px]">
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 gap-x-12 container">
          
          <!-- Reference Number Field -->
          <div class="container  !pt-0 !pl-0 !pb-0">
            <div class="rounded !pb-0 !pt-0 !mb-[40px]">
              <mat-form-field class="!w-[100%] !mb-[0px]" appearance="outline">
                <mat-label>Reference Number</mat-label>
                <input
                  matInput
                  placeholder="Reference Number"
                  value={{initialData?.refrenceNumber}}
                  [readonly]="true"
                />
              </mat-form-field>
            </div>
          </div>
    
          <!-- Client/Authority Field -->
          <div class="container !pb-0 !pt-0">
            <div class="rounded !pb-0 !pt-0 !mb-[40px]">
              <mat-form-field class="!w-[100%] !mb-[0px]" appearance="outline">
                <mat-label>Client/Authority</mat-label>
                <input
                  matInput
                  placeholder="Client/Authority"
                  value={{initialData?.client}}
                  [readonly]="true"
                />
              </mat-form-field>
            </div>
          </div>
    
          <!-- Date Issued Field -->
          <div class="container  !pb-0 !pl-0 !pt-0">
            <div class="rounded !pb-0 !pt-0 !mb-[40px]">
              <mat-form-field class="!w-[100%] !mb-[0px]" appearance="outline">
                <mat-label>Issued Date</mat-label>
                <input
                  type="date"
                  matInput
                  placeholder="Date Issued"
                  value={{initialData?.issueDate}}
                  [readonly]="true"
                />
              </mat-form-field>
            </div>
          </div>
    
          <!-- Submission Deadline Field -->
          <div class="container  !pb-0 !pt-0">
            <div class="rounded !pb-0 !pt-0 !mb-[40px]">
              <mat-form-field class="!w-[100%] !mb-[0px]" appearance="outline">
                <mat-label>Submission Deadline</mat-label>
                <input
                  type="date"
                  matInput
                  placeholder="Submission Deadline"
                  value={{initialData?.submissionDeadline}}
                  [readonly]="true"
                />
              </mat-form-field>
            </div>
          </div>
    
        </div>
      </div>
    </div>
    
  </div>